import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var FORMATS = {
  Online: 'online',
  Offline: 'offline',
  Hybrid: 'hybrid'
};
export var FORMAT_LABELS = _defineProperty(_defineProperty(_defineProperty({}, FORMATS.Online, 'Онлайн'), FORMATS.Offline, 'Офлайн'), FORMATS.Hybrid, 'Гибрид');
export var AUDIENCES = {
  It: 'it',
  Students: 'students',
  Business: 'business'
};
export var AUDIENCE_LABELS = _defineProperty(_defineProperty(_defineProperty({}, AUDIENCES.It, 'Для IT'), AUDIENCES.Students, 'Для студентов'), AUDIENCES.Business, 'Для бизнеса');